import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { RootState } from "~/store"
import { Config } from "~/model/Config"
import axios from "axios"
import API from "~/api/api"

export const fetchConfig = createAsyncThunk("config/fetchConfig", async () => {
  const config = await axios.get<{ data: Config }>(API.CONFIG).then((response) => response.data.data)
  return { config }
})

export const configSlice = createSlice({
  name: "config",
  initialState: {
    masters: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchConfig.fulfilled, (state, action) => {
      Object.assign(state, action.payload.config)
    })
  },
})
export const {} = configSlice.actions
export const selectConfig = (state: RootState) => state.config
export default configSlice.reducer
